import { get_3 } from "./api";
import URLS from "../constants/api";

export const getContactUs = async (
  page: number,
  limit: number,
  // searchOn: string,
  search: string,
  sortOrder: string,
  sortBy: string
) => {
  const requestData = {
    params: {
      page,
      limit,
      // ...(searchOn !== "" && { searchOn }),
      ...(search !== "" && { search }),
      ...(sortOrder !== "" && { sortOrder }),
      ...(sortBy !== "" && { sortBy }),
    },
  };
  const response = await get_3(URLS.GET_CONTACTUS, requestData);

  return response;
};
